import { type EventFlow } from '@solinkcorp/api-types';
import { type IEvent } from 'clients/PlatformApi';
import React from 'react';
import { useFeatureStandard } from 'utils/EventStandardCache/eventStandardCache';
import { getFirstApplicableWorkflow } from './EventVerify/verifyUtils';

/**
 * Get the first available event flow for the current event.
 */
export default function useEventFlow(event: IEvent, workflows: EventFlow[] | undefined) {
  const featureStandard = useFeatureStandard();
  return React.useMemo(
    () => (workflows ? getFirstApplicableWorkflow(event, workflows, featureStandard) : undefined),
    [event, workflows, featureStandard],
  );
}
